import axiosapi from "./axiosAPI";

// Get All Disabilities
export const getAllDisabilities = async (
    setDisabilities,
    setFetcherror,
    
) => {
    
    
	try{
		const res =await axiosapi.get("/disabilities");
        setDisabilities(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Disabilities");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Disabilities");
		}
		
	}
	
};



// Get One Disability
export const getOneDisability = async (
    pkid,
    setFetcherror,  
    setDisability
    
)=>{
	try{
		const res =await axiosapi.get(`/disabilities/${pkid}`);
        setDisability(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Disability");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Disability");
		}
		
	}
	
};


// Create New Disability
export const createDisability = async (
    disability,
    setDisability,
    setFetcherror,
    handleAllToasts,
    setDisabilities

) => {

    if (!disability ) {
        handleAllToasts(2, "No Disability Provided"); 
            return; 
        }

    const PushItem = {
            name: disability,
        };

    try{
        await axiosapi.post("/disabilities/",PushItem );
        setDisability("");
        handleAllToasts(1, "Disability Created Successfully");
        getAllDisabilities(setDisabilities,setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Disability");
            handleAllToasts(2, "Could Not update The Disability");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Disability");
            handleAllToasts(2, "Could Not update The Disability");
            
        }
        
    }
    
}


// Edit Existing Disability

export const editDisability = async (
    disabilitypkid,
    disability,
    setDisability,
    setFetcherror,
    handleAllToasts,
    setDisabilities
              
        ) => {

            if (!disability) {
                handleAllToasts(2, "No Disability Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:disabilitypkid,
                    name: disability,
                };

            try{
                await axiosapi.patch("/disabilities/",PushItem );
                setDisability("");
                handleAllToasts(1, "Disability Updated Successfully");
                getAllDisabilities(setDisabilities,setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Disability");
                    handleAllToasts(2, "Could Not Update Disability");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Disability");
                    handleAllToasts(2, "Could Not Update Disability");
                    
                }
                
            }
            
};



// Delete Existing Disability.

export const deleteDisability = async (
    disabilitypkid,
    setDisabilities,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/disabilities/${disabilitypkid}`);
        let finalData = res.data.message;
        getAllDisabilities(setDisabilities, setFetcherror);
        handleAllToasts(1, "Disability Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Disability");
            handleAllToasts(2,"Error: Could Not Delete Disability");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Disability");
            handleAllToasts(2,"Error: Could Not Delete Disability");
		}
		
	}
	
};